import { WalkInService } from '@/services/walk-in.service';
import type { ProfileWalkInsResponse } from '@/types/dto/walk-in.dto';
import type { QueryClient } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';

const WALK_IN_QUERY_DEFAULTS = {
  retry: false,
  staleTime: 0,
  refetchOnWindowFocus: false,
} as const;

export const walkInQueryKeys = {
  all: ['walk-in'] as const,
  profileLists: (viewerId?: string | null) => [...walkInQueryKeys.all, 'profile', viewerId ?? null] as const,
  profile: (viewerId?: string | null) => [...walkInQueryKeys.profileLists(viewerId), 'list'] as const,
};

export const walkInQueryOptions = {
  profile: (viewerId?: string | null, enabled = true) =>
    queryOptions<ProfileWalkInsResponse>({
      queryKey: walkInQueryKeys.profile(viewerId),
      enabled: enabled && Boolean(viewerId),
      queryFn: () => WalkInService.list(),
      ...WALK_IN_QUERY_DEFAULTS,
    }),
};

export async function refreshProfileWalkInsCache(queryClient: QueryClient, viewerId?: string | null) {
  const queryKey = walkInQueryKeys.profileLists(viewerId);

  await queryClient.invalidateQueries({ queryKey });
  await queryClient.refetchQueries({ queryKey, type: 'active' });
}
